import { type DropdownProps } from "semantic-ui-react";
import { useMemo } from "react";

import { ContentTypesEnum } from "../../../enums";
import MultiStateDropdown, { type MultiStateDropdownOption } from "../multiStateDropdown/MultiStateDropdown";
import EmbeddedVideoIcon from "components/icons/EmbeddedVideoIcon";

import { faVideoArrowUpRight } from "@fortawesome/pro-solid-svg-icons";

const embeddedOption: MultiStateDropdownOption<ContentTypesEnum> = {
  label: ContentTypesEnum.Embedded,
  renderIcon: (className?: string) => <EmbeddedVideoIcon className={className} />,
};

const uploadedOption: MultiStateDropdownOption<ContentTypesEnum> = {
  label: ContentTypesEnum.Uploaded,
  icon: faVideoArrowUpRight,
};

const getVideoOptions = (): MultiStateDropdownOption<ContentTypesEnum>[] => [uploadedOption, embeddedOption];

const getDefaultOption = (label: ContentTypesEnum) =>
  label === ContentTypesEnum.Embedded ? embeddedOption : uploadedOption;
interface VideosSegmentationDropdownProps extends DropdownProps {
  options?: MultiStateDropdownOption<ContentTypesEnum>[];
  defaultValue?: ContentTypesEnum;
}

export default function VideosSegmentationDropdown(props: VideosSegmentationDropdownProps) {
  const contentOptions = useMemo(() => getVideoOptions(), []);

  return (
    <MultiStateDropdown
      options={contentOptions}
      defaultOption={props.defaultValue ? getDefaultOption(props.defaultValue) : contentOptions[0]}
      {...props}
    />
  );
}
